import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../components/card/card.jsx";
import { asset, machineProfile } from "../../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../../contexts/AuthContext.jsx";
import { useDashboardContext } from "../../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import {
  formatDateOnly,
  generateLocationToArray,
  Loader,
} from "../../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../../components/LocationFilter/index.jsx";
import { matar } from "../../../api/index.js";
import { staticData } from "./static-data";

function MachineList() {
  const [datas, setDatas] = useState(staticData);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState({ company: true });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const { updateMachineProfile } = useAuth();
  const canUpdate = updateMachineProfile();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const getStatus = (status) => {
    switch (status) {
      case "Acceptable":
        return "status-accept";
      case "Observe":
        return "status-observe";
      case "Alert":
        return "status-alert";
      case "Critical":
        return "status-critical";
      default:
        return "status-pending";
    }
  };
  const columns = [
    {
      name: <div>Asset ID</div>,
      selector: (row) => row["id"],
      style: { whiteSpace: "unset" },
      minWidth: "200px",
      wrap: true,
      maxWidth: "200px",
    },
    {
      name: "Asset Name",
      selector: (row) => row["machine_name"],
      style: { whiteSpace: "unset" },
      minWidth: "300px",
      wrap: true,
      maxWidth: "300px",
    },
    {
      name: "Machine Health by GINA.AI",
      selector: (row) => row["machine_health"],
      style: { whiteSpace: "unset" },
      minWidth: "200px",
      wrap: true,
      maxWidth: "200px",
      cell: (row) => (
        <div
          style={{
            margin: "auto",
            textAlign: "center",
            width: "100px",
            color: "#2A2E5D",
          }}
          className={getStatus(row.machine_health)}
        >
          {row.machine_health ? row.machine_health : "Pending"}
        </div>
      ),
    },
    {
      name: "Asset Category",
      selector: (row) => row["machine_model_no"],
      style: { whiteSpace: "unset" },
      wrap: true,
      minWidth: "200px",
      maxWidth: "200px",
    },
    {
      name: <div>Replacement Year Based on RUL</div>,
      selector: (row) => row["Forecasted Replacement Date"],
      minWidth: "170px",
      maxWidth: "170px",
      cell: (row) => row?.MachineStrategies[0]?.replacement_year,
    },
    {
      name: <div>CAPEX</div>,
      selector: (row) => row["maintenance"],
      minWidth: "150px",
      maxWidth: "150px",
      cell: (row) => row?.MachineStrategies[0]?.default_capex,
    },
  ];
  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-9">
                <div>
                  Asset ID : <b>{data["id"]}</b>
                </div>
                <div>
                  Asset Name : <b>{data["machine_name"]}</b>
                </div>
                <div>
                  Asset Category : <b>{data["machine_model_no"]}</b>
                </div>
                <div>
                  Replacement Year :{" "}
                  <b>{data?.MachineStrategies[0]?.replacement_year}</b>
                </div>
                <hr />
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() =>
                    navigate(
                      "/machine-asset/rul-detail/" +
                        data["id"] +
                        "?withSensor=true"
                    )
                  }
                  type="button"
                  className="btn btn-outline-theme"
                >
                  <i class="fa fa-chart-area"></i> View RUL
                </button>
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() =>
                    navigate("/machine-asset/lifecycle/" + data["id"])
                  }
                  type="button"
                  className="btn btn-outline-theme"
                >
                  <i class="fa fa-money-bill-trend-up"></i> View Lifecycle Cost
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeMachineType = (machine_type_id) => {
    setQuery((prev) => ({
      ...prev,
      machine_type_id: machine_type_id,
    }));
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Asset</a>
            </li>
            <li className="breadcrumb-item active">Asset List</li>
          </ul>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <Loader loading={loading}>
                      <DataTable
                        paginationPerPage={20}
                        paginationRowsPerPageOptions={[20]}
                        highlightOnHover
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        paginationServer
                        paginationTotalRows={totalPage * 20}
                        onChangePage={handlePageChange}
                      />
                    </Loader>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineList;
